import React, { useEffect } from "react";
import { logEvent, logScreenView } from "utils/analytics";
import { getScreenName, trackAnalyticsScreenParams } from "utils/route";
import { useLocation } from "react-router-dom";

const PageTracker: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    const stateParams = location.state ?? {};
    const screenName = getScreenName(location.pathname);

    if (screenName) {
      const { params, eventName } =
        trackAnalyticsScreenParams(screenName, stateParams) ?? {};

      logScreenView({ screenName, pathname: location.pathname });

      if (params && eventName) {
        logEvent({
          event: eventName,
          data: params,
        });
      }
    }
  }, [location]);

  return null;
};

export default PageTracker;
